import React from "react";
import { Controller } from "react-hook-form";

const CheckBoxSelection = ({
  name,
  mapitems,
  control,
  errors,
  label,
  isMandatory,
  isRequired,
}) => {
  return (
    <div>
      {/* Label */}
      <div className="xs:text-sm sm:text-base font-onestRegular text-secondary flex justify-start items-center">
        <div>{label}</div>
        <p className="text-errorRed pl-1 text-lg leading-3">
          {isMandatory ? "*" : ""}
        </p>
      </div>

      {/* Job Selection */}
      <Controller
        name={name}
        control={control}
        rules={isRequired ? { required: `${label} selection is required` } : {}}
        render={({ field }) => (
          <div className="flex items-center flex-wrap gap-x-4 gap-y-2 pt-2">
            {mapitems?.map((value) => (
              <label
                key={value?.id}
                className="custom-radio cursor-pointer flex justify-center items-center md:text-[17px] text-[18px] 3xl:text-[20px] font-raleway"
              >
                <input
                  type="checkbox"
                  value={value?.id}
                  checked={parseInt(field.value) === parseInt(value?.id)}
                  onChange={() => field.onChange(value?.id)}
                  className="hidden peer"
                />
                <span className="w-7 h-7 inline-block bg-[#212121] rounded-[3px] peer-checked:bg-goldMetallic peer-checked:after:content-['✓'] peer-checked:after:block peer-checked:after:text-black peer-checked:after:text-center peer-checked:after:leading-7"></span>
                <p className="font-onestRegular xs:text-sm sm:text-lg text-secondary ml-2">
                  {value?.title}
                </p>
              </label>
            ))}
          </div>
        )}
      />

      {/* Error Message */}
      <div className="flex justify-start items-center pt-1">
        {errors[name] && (
          <span className="text-orangeCrayola font-onestRegular xs:text-xs sm:text-sm">
            {errors[name].message}
          </span>
        )}
      </div>
    </div>
  );
};

export default CheckBoxSelection;
